import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  IUserWizardFormModel,
  userWizardFormDefaultValues,
  userWizardFormSchema,
} from "../models/userWizardFormModel";
import { useEffect } from "react";
import { useFormValidationMessages } from "../../../../../common/infrastructure/hooks/useFormHelper";

export const useUserWizardForm = (
  selectedStudioId: number,
  user?: IUserWizardFormModel
) => {
  const form = useForm<IUserWizardFormModel>({
    defaultValues: userWizardFormDefaultValues,
    resolver: yupResolver(userWizardFormSchema),
  });

  useEffect(() => {
    form.setValue("studioId", selectedStudioId);

    if (user) {
      if (user.phoneNumber) {
        form.setValue("phoneNumber", user.phoneNumber);
      }

      form.setValue("email", user.email);
      form.setValue("firstName", user.firstName);
      form.setValue("lastName", user.lastName);
      form.setValue("additionalInfo", user.additionalInfo);
      form.setValue("id", user.id);
      form.setValue("studioId", user.studioId);
      form.setValue(
        "scheduleVisibilityDaysAhead",
        user.scheduleVisibilityDaysAhead
      );
      form.setValue("birthDate", user.birthDate ? new Date(user.birthDate) : null);
      form.setValue("fontSizePercent", user.fontSizePercent ?? 100);
      form.setValue("rfidBandId", user.rfidBandId ?? "");
    }
  }, [user, selectedStudioId]);

  useFormValidationMessages<IUserWizardFormModel>(form);

  return form;
};
